import { render } from "./PerformanceOverall.vue?vue&type=template&id=4498b5a2"
import script from "./PerformanceOverall.vue?vue&type=script&lang=js"
export * from "./PerformanceOverall.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__